import { useMemo } from 'react';

import { capitalizeFirstLetter } from 'src/app/utils/formatters';

import { DiscountFirstTimeCustomer } from '../../models';
import { useDiscountWizardStateContext } from '../state';

import { useSelectedDetailsResources } from './use-selected-details-resources';

export function useSyncDisabledStatus() {
  const {
    detailsStepState: { firstTimeCustomerOption, limitPerCustomer },
  } = useDiscountWizardStateContext();
  const { selectedCustomerGroups, selectedCustomerSegments } = useSelectedDetailsResources();

  const selectedCustomerGroupsDisabledSync = selectedCustomerGroups.length > 0;
  const selectedCustomerSegmentsDisabledSync = selectedCustomerSegments.length > 0;
  const customerLimitDisabledSync = limitPerCustomer;
  const firstTimeCustomerDisabledSync = firstTimeCustomerOption !== DiscountFirstTimeCustomer.NoFirstTimeDiscount;
  const syncDisabled = [
    selectedCustomerGroupsDisabledSync,
    customerLimitDisabledSync,
    firstTimeCustomerDisabledSync,
    selectedCustomerSegmentsDisabledSync,
  ].some((disabled) => disabled);

  const syncDisabledWarningText = useMemo(() => {
    const warnings: string[] = [];

    if (selectedCustomerGroupsDisabledSync) {
      warnings.push('customer groups');
    }
    if (selectedCustomerSegmentsDisabledSync) {
      warnings.push('customer segments');
    }
    if (customerLimitDisabledSync) {
      warnings.push('customer limit');
    }
    if (firstTimeCustomerDisabledSync) {
      warnings.push('first time customer');
    }
    return warnings.length > 0 ? capitalizeFirstLetter(warnings.join(', ')) : '';
  }, [
    selectedCustomerGroupsDisabledSync,
    customerLimitDisabledSync,
    firstTimeCustomerDisabledSync,
    selectedCustomerSegmentsDisabledSync,
  ]);

  return useMemo(
    () => ({
      customerLimitDisabledSync,
      firstTimeCustomerDisabledSync,
      selectedCustomerGroupsDisabledSync,
      syncDisabled,
      syncDisabledWarningText,
      selectedCustomerSegmentsDisabledSync,
    }),
    [
      customerLimitDisabledSync,
      firstTimeCustomerDisabledSync,
      selectedCustomerGroupsDisabledSync,
      syncDisabled,
      syncDisabledWarningText,
      selectedCustomerSegmentsDisabledSync,
    ]
  );
}
